module.exports = __webpack_public_path__ + "static/img/banner.72d78503.jpg";